<template>
    <footer class="footer">
          <div class="container-fluid clearfix">
            <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © 2018   All rights reserved.</span>
            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">当前版本：v0.0.1 (更新于2018/12/7)
              <i class="mdi mdi-heart text-danger"></i>
            </span>
          </div>
        </footer>
</template>
<script>
export default {

}
</script>
